/**
 * Module-Level Service Singletons
 *
 * Provides stable, module-level singleton instances. Components import
 * these directly instead of creating new instances per render.
 *
 * Initialized once at module load time. The TokenService reads from
 * sessionStorage, so singletons are valid for the lifetime of the browser tab.
 *
 * Usage:
 *   import { tokenService, backendService } from '../services/ServiceInstances';
 */

import { TokenService } from './TokenService';
import { LoginService } from './LoginService';
import { BackendService } from './BackendService';

// Core services — created once, shared everywhere
export const tokenService = new TokenService();
export const loginService = new LoginService(tokenService);
export const backendService = new BackendService(tokenService, loginService);
